<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon @click="editRecord" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"/>
    <feather-icon @click="confirmDeleteRecord" icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"/>
    <feather-icon @click="confirmRemoveTermFromSetRecord" icon="DeleteIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer ml-4" v-if="params.api.setId !== ''"/>
  </div>
</template>

<script>
export default {
  methods: {
    editRecord () {
      this.$router.push(`terms/${this.params.data.id}`).catch(() => {
      })
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',

        title: 'Confirm Delete',
        text: 'Please confirm you want to delete this term.',
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {

      this.$vs.loading()

      this.$http.delete(`terms/${this.params.data.id}`)
        .then(response => {
          this.$vs.loading.close()
          if (response.status === 200) {
            this.params.loadProductBuffer()

            return this.$vs.notify({
              color: 'success',
              title: 'Term Deleted',
              text: 'You have successfully deleted this term',
              position: 'top-right'
            })
          }

          this.showError({response})
        })
        .catch(this.showError)

    },
    confirmRemoveTermFromSetRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',

        title: 'Confirm Remove Term From Set',
        text: 'Please confirm you want to remove this term from the filtered set',
        accept: this.removeTermFromSetRecord,
        acceptText: 'Confirm'
      })
    },
    removeTermFromSetRecord () {

      this.$vs.loading()

      this.$http.post(`sets/${this.params.api.setId}/terms/delete`, [this.params.data.id])
        .then(response => {
          this.$vs.loading.close()
          if (response.status === 200) {
            this.params.loadProductBuffer()

            return this.$vs.notify({
              color: 'success',
              title: 'Term Removed From Set',
              text: 'You have successfully removed this term from the filtered set',
              position: 'top-right'
            })
          }
          this.showError({response})
        })
        .catch(this.showError)

    },
    showError (exception) {
      this.$vs.loading.close()

      let error = 'An unknown error occurred while archive this term'
      if (exception.response) {
        error = exception.response.data.data.message
      }

      return this.$vs.notify({
        title: 'Failed to archive term',
        text: error,
        color: 'danger',
        position: 'top-right'
      })
    }
  }
}
</script>
